import { exportToExcel } from "../utils/excel";
import { FaFileExcel } from "react-icons/fa";

const ExcelExportButton = (arranged_data) => {
  const handleExport = () => {
    const sheet1 = arranged_data.data;
    const sheet1_name = 'Overall Ticket Report';
    const sheet2 = arranged_data.data2;
    const sheet2_name = 'Consolidated Ticket Report';
    const excel_name = 'Overall_Ticket_Report.xlsx';
    exportToExcel(sheet1, sheet1_name, sheet2, sheet2_name, excel_name);
  };

  return (
    <button
      onClick={handleExport}
      className="flex text-xs items-center gap-2 bg-red-700 hover:bg-red-600 text-white font-bold py-2 px-4 rounded-full"
    >
      <FaFileExcel className="w-4 h-4" />
      <span>Export Excel</span>
    </button>
  );
};

export default ExcelExportButton;
